import { useMutation, UseMutationOptions } from "@tanstack/react-query"

import { httpClient } from "~/backend/axios.ts"
import { queryClient } from "~/backend/queryClient.ts"

export const useDeleteProductionSiteMutation = (
  productionSiteId: string,
  options?: UseMutationOptions<void, unknown>
) => {
  return useMutation({
    ...options,
    mutationFn: async () => {
      await httpClient.delete(`/production-sites/${productionSiteId}`)
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
      queryClient.invalidateQueries({
        queryKey: ["listProductionSites"],
      })
    },
  })
}
